import { useLocation } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { DASHBOARD_CONTENT_CONTAINER_ID } from '@/router/pageConst'
import ProjectPageContent from '@/pages/ProjectPage/components/ProjectPageContent/ProjectPageContent'
import ExperienceProjectDetailPage from '@/pages/ExperienceProjectDetailPage/ExperienceProjectDetailPage'

function PortraitSurveyProjectPage() {
  const location = useLocation()
  const isDetail = location.state && location.state.id
  const scorllTop = useRef(0)
  const [whichProjectDetail, setWhichProjectDetail] = useState<ProjectModels.ProjectDetailV3 | null>(
    null
  )

  useEffect(() => {
    const dashboardContent = document.getElementById(DASHBOARD_CONTENT_CONTAINER_ID)!
    if (isDetail) {
      dashboardContent.scrollTo({ top: 0 })
    } else {
      dashboardContent.scrollTo({ top: scorllTop.current })
    }
    const handleScroll = (e: Event) => {
      if (!isDetail) {
        const target = e.target as HTMLElement
        scorllTop.current = target.scrollTop
      }
    }
    dashboardContent.addEventListener('scroll', handleScroll)
    return () => {
      dashboardContent.removeEventListener('scroll', handleScroll)
    }
  }, [isDetail])

  return (
    <>
      <div style={{ display: isDetail ? 'none' : 'block', opacity: isDetail ? 0 : 1 }}>
        <ProjectPageContent isDetailMode={isDetail} whichProjectDetail={whichProjectDetail} />
      </div>
      {isDetail && (
        <ExperienceProjectDetailPage
          onProjectDetailUpdate={(project) => {
            setWhichProjectDetail(project)
          }}
        />
      )}
    </>
  )
}

export default observer(PortraitSurveyProjectPage)
